import React from 'react';
import { observer } from 'mobx-react';
import { DiagnosisCodeListTemplate } from 'themes/application/diagnosis-code/pages';
import { setCurrentView } from 'core/utils';
import { DiagnosisCodeListViewStore } from 'application/diagnosis-code/stores';

@setCurrentView((rootStore) => new DiagnosisCodeListViewStore(rootStore), 'diagnosisCodeListViewStore')
@observer
class DiagnosisCodeList extends React.Component {
    render() {
        return <DiagnosisCodeListTemplate {...this.props} />
    }
}

export default DiagnosisCodeList;